import { Component, OnDestroy, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject} from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { fuseAnimations } from '@fuse/animations';
import { FuseConfigService } from '@fuse/services/config.service';
import { ActivatedRoute, Router } from '@angular/router';

import { HomeService } from 'app/main/service/home.service';

import { FclService } from 'app/main/service/fcl.service';
import { SupplierService } from 'app/main/service/supplier.service';
import { CountryService } from 'app/main/service/country.service';
import { SeaportService } from 'app/main/service/seaport.service';
import { FclInfoService } from 'app/main/service/fcl-info.service';
import { FclPriceService } from 'app/main/service/fcl-price.service';

import { MatDialog, MatDialogRef } from '@angular/material';
import { DatePipe } from '@angular/common';

@Component({
    selector     : 'fcl-price',
    templateUrl  : './fcl-price.component.html',
    styleUrls    : ['./fcl-price.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class FclPriceComponent implements OnInit, OnDestroy
{
    quantity;
    type = 0;
    fclPrice: any[];
    fcl: any[];
    package: any[];
    currency: any[];
    price: any[];
    unit;
    paymentCenter;
    filterFclPrice;
    unitForm = this._formBuilder.group({
        unit: [0],
        paymentCenter: [0]
    });
    dialogRef: any;
    errorMessage = '';
    requestProcessing = false;
    volume;

    //refresh: Subject<any> = new Subject();

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {PriceListService} _vesselInfoService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private homeService: HomeService, 
        private router: Router, 
        private route: ActivatedRoute, 
        private _formBuilder: FormBuilder,
        private datePipe: DatePipe,
        private _matDialog: MatDialog,
        private fclInfoService: FclInfoService,
        private fclPriceService: FclPriceService,
    )
    {
        // Set the private defaults
        this._unsubscribeAll = new Subject();

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        //let id = this.route.snapshot.params['vessel_id'];
        this.fclInfoService.onFclInfoPriceChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(data => {
                this.fclPrice = data[0];
                this.fcl = data[1];
                this.package = data[2];
                this.currency = data[3];
                this.price = data[4];
                let length = data[0].length;
                let unit = data[0].map(a => a.unit.code).sort();
                let unique = (arrArg) => arrArg.filter((elem, pos, arr) => arr.indexOf(elem) == pos);
                unit = unique(unit);
                let index = unit.indexOf('SPT');
                if(index !== -1) unit.splice(index, 1);
                this.unit = unit;
                
                let paymentCenter = [];
                for(let i = 0; i < length; i++){
                    if(data[0][i].payment_center != '') paymentCenter.push(data[0][i].payment_center);
                }
                paymentCenter.sort();
                this.paymentCenter = unique(paymentCenter);
                console.log(this.fcl);
                let val = this.unitForm.controls.unit.value;
                if(val == 0){
                    this.filterFclPrice = this.fclPrice.slice();
                } else {
                    this.filterFclPrice = this.fclPrice.filter(item => item.unit.id === val || item.unit.code == 'SPT');
                }

            });
        this.unitForm.controls.unit.valueChanges.subscribe(unitValue => {
            let paymentValue = this.unitForm.controls.paymentCenter.value;
            if(unitValue == 0 && paymentValue == 0){
                this.filterFclPrice = this.fclPrice.slice();
            } else if(unitValue != 0 && paymentValue == 0){
                this.filterFclPrice = this.fclPrice.filter(item => item.unit.code === unitValue || item.unit.code == 'SPT');
            } else if(unitValue == 0 && paymentValue != 0){
                this.filterFclPrice = this.fclPrice.filter(item => item.payment_center === paymentValue);
            } else {
                this.filterFclPrice = this.fclPrice.filter(item => (item.unit.code === unitValue || item.unit.code == 'SPT') && item.payment_center === paymentValue);
            }
        });
        this.unitForm.controls.paymentCenter.valueChanges.subscribe(paymentValue => {
            let unitValue = this.unitForm.controls.unit.value;
            if(unitValue == 0 && paymentValue == 0){
                this.filterFclPrice = this.fclPrice.slice();
            } else if(unitValue != 0 && paymentValue == 0){
                this.filterFclPrice = this.fclPrice.filter(item => item.unit.code === unitValue || item.unit.code == 'SPT');
            } else if(unitValue == 0 && paymentValue != 0){
                this.filterFclPrice = this.fclPrice.filter(item => item.payment_center === paymentValue);
            } else {
                this.filterFclPrice = this.fclPrice.filter(item => (item.unit.code === unitValue || item.unit.code == 'SPT') && item.payment_center === paymentValue);
            }
        });
        //kiem tra co du lieu hay ko
        if(this.homeService.search){
            this.quantity = this.homeService.search.volume.quantity;
        } 
        if(this.homeService.voyage){
            if(this.homeService.voyage.unit){
                this.type = this.homeService.voyage.unit;
            } else {
                let volume = this.homeService.search.volume;
                let length = volume.length;
                for (let i = length - 1; i > 0; i--){
                    if(this.unit.includes(volume[i].name)) this.type = volume[i].name;
                }
            }
        }
        this.unitForm.controls.unit.setValue(this.type);
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
    searchUnit(obj){
        

    }

}
